import React from "react";
import "./StyleEmptyState.scss";
import { useSelector } from 'react-redux'

const EmptyState = (props) => {
     const { ReactBusinessId } = useSelector((state) => state.Business);
     return (
          <div className={`empty-state-wrap ${props.wrapperClass}`}>
               <div className="empty-state">
                    {props.stateIcon && (
                         <i className={`icon far ${props.stateIcon}`}></i>
                    )}
                    {props.stateTitle && (
                         <div className="title">{props.stateTitle}</div>
                    )}
                    {ReactBusinessId == 0 &&
                         props.stateDescription && (
                              <div className="desc">{props.stateDescription}</div>
                         )
                    }
                    {ReactBusinessId == 0 &&
                         props.stateButtonText && props.stateButtonActions && (
                              <button
                                   type="button"
                                   className="w-button w-button-neutral"
                                   onClick={props.OpenPopup}
                              >
                                   
                                   {props.stateButtonText}
                              </button>
                         )
                    }
               </div>
          </div>
     );
};

export default EmptyState;
